<style lang="less" scoped>
  @import "./cd-1px-b.less";

  .confirm {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1000;
  }

  .b {
    position: absolute;
    width: 13.5rem;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #fff;
    border-radius: 0.5rem;
    overflow: hidden;
    font-size: 0.65rem;
    color: #404040;
  }
  .confirm.style1 .b {
    border-radius: 0;
  }

  .text {
    padding: 0.875rem;
    word-break: break-all;
    word-wrap: break-word;
    text-align: center;
    .cd-1px-b (@color: #e0e0e0, @solidType: solid)
  }

  .btn {
    line-height: 2.1rem;
    height: 2.1rem;
    font-size: 0.85rem;
    text-align: center;
  }

  .btn .l {
    color: #157efb;
  }

  .title {
    font-size: .8rem;
    font-weight: bold;

  }

  .show-content {
    display: -webkit-flex;
    display: flex;
    -webkit-flex-direction: row;
    flex-direction: row;
    -webkit-align-items: center;
    align-items: center;
    font-size: 0.7rem;
  }
  .m-h{
    min-height: 2.7rem;
  }
</style>
<template>
  <transition name="fade" mode="out-in" appear>
    <div v-show="showFlag" class="confirm" :class="style">
      <div class="b">
        <div class="text">
          <div class="title f-tac f-wwb" v-html="showTitle"></div>
          <div class="show-content" :class="{'m-h':showText}">
            <div @click="$emit('click',$event)" class="f-tac f-wwb" style="flex-grow: 1;" v-html="showText"></div>
          </div>
        </div>
        <div class="btn flex-box" @click="confirm">
          <a class="f-db f-tac flex1 l"  v-html="button"></a>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
  export default {
    data() {
      return {
        closeTimer: null,
        showFlag: false,
        text: '',
        title: '',
        onYes: null,
        button: '确定',
      };
    },
    props:['styleType'],
    computed: {
      showText: function() {
        var re = '';
        if (this.text) {
          re = this.text.replace(/<script.*>/, '').replace(/<\/script>/, '');
        }
        return re;
      },
      showTitle() {
        var re = '';
        if (this.title) {
          re = this.title.replace(/<script.*>/, '').replace(/<\/script>/, '');
        }
        return re;
      },
      style() {
        return 'style'+ this.styleType;
      }
    },
    methods: {
      confirm() {
        if (this.closeTimer) {
          clearTimeout(this.closeTimer);
          this.closeTimer = null;
        }
        this.showFlag = false;
        if (this.onYes) {
          this.onYes();
          this.onYes = null;
        }
      },
      show(opt) {
        if(opt && typeof opt !== 'object'){
          opt = {text:opt}
        }
        opt = Object.assign({
          title: '',
          text: '',
          cb: null,
          time: 0,
          button: '确定',
        }, opt);
        this.onYes = opt.cb;
        this.button = opt.button+'';
        this.title = opt.title+'';
        this.text = opt.text+'';
        this.showFlag = true;
        if (this.closeTimer) {
          clearTimeout(this.closeTimer);
          this.closeTimer = null;
        }
        if (opt.time >= 1000 && opt.time <= 10000) {
          this.closeTimer = setTimeout(() => { this.confirm();}, opt.time);
        }
      },
    },
  };
</script>
